import { LocalStorageEncryptionKey } from './local-storage-crypto.util';

const keyState: { encryptionKey: LocalStorageEncryptionKey | null } = {
  encryptionKey: null,
};

let onEncryptionKeyReady: (() => void) | null = null;

type LocalStorageEncryptionWarningHandler = (
  message: string,
  context?: Record<string, unknown>
) => void;

let onEncryptionWarning: LocalStorageEncryptionWarningHandler | null = null;
const pendingEncryptionWarnings: Array<{
  message: string;
  context?: Record<string, unknown>;
}> = [];

export function registerLocalStorageEncryptionWarningHandler(
  handler: LocalStorageEncryptionWarningHandler
): void {
  onEncryptionWarning = handler;
  pendingEncryptionWarnings.forEach(({ message, context }) => {
    handler(message, context);
  });
  pendingEncryptionWarnings.length = 0;
}

export function warnLocalStorageEncryption(
  message: string,
  context?: Record<string, unknown>
): void {
  if (onEncryptionWarning) {
    onEncryptionWarning(message, context);
    return;
  }

  pendingEncryptionWarnings.push({ message, context });
}

export function registerLocalStorageEncryptionKeyReadyHandler(
  handler: () => void
): void {
  onEncryptionKeyReady = handler;
}

export function getLocalStorageEncryptionKey(): LocalStorageEncryptionKey | null {
  return keyState.encryptionKey;
}

export function setLocalStorageEncryptionKey(
  key: LocalStorageEncryptionKey | null
): void {
  const wasReady = isLocalStorageEncryptionKeyReady();
  keyState.encryptionKey = key;

  if (!wasReady && isLocalStorageEncryptionKeyReady()) {
    onEncryptionKeyReady?.();
  }
}

export function isLocalStorageEncryptionKeyReady(): boolean {
  return keyState.encryptionKey !== null && keyState.encryptionKey.length > 0;
}
